// extracted by mini-css-extract-plugin
export var truncate = "_j-0";